import { Component, Inject, Renderer2 } from '@angular/core';
import * as AOS from 'aos';

import { Title, Meta } from '@angular/platform-browser';

import { Constants } from '../../common/constants';
import { DOCUMENT } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-h1b-visa-blog',
  templateUrl: './h1b-visa-blog.component.html',
  styleUrls: ['./h1b-visa-blog.component.css']
})
export class H1bVisaBlogComponent {
  baseUrl=Constants.baseUrl;

  constructor(
    private titleService: Title,private seoService:SeoService,
    private metaService: Meta,   private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document
  ) {}
  ngOnInit(): void {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/h1b-visa/"
  },
  "headline": "What is an H1B Visa?",
  "description": "Generally known as a work visa, H-1B is a non-immigrant employment-based visa provided to an eligible temporary worker. The H-1B visa allows a foreign national to work in the United States for a temporary period.",
  "image": "",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT Resources",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2022-11-11"
}`;
   
    this._renderer2.appendChild(this._document.head, script);

    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

 private setTitleAndMetaTags(): void {
    this.titleService.setTitle('What is an H1B Visa?');

    this.metaService.addTags([
      { name: 'description', content: 'Generally known as a work visa, H-1B is a non-immigrant employment-based visa provided to an eligible temporary worker!' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'What is an H1B Visa?' },
      { property: 'og:url', content: 'https://mitresource.com/h1b-visa/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/owen_christimage.png' },
      { property: 'og:description', content: 'Generally known as a work visa, H-1B is a non-immigrant employment-based visa provided to an eligible temporary worker.' },
    ]);
  }
}
